import React, { useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";
import { Slide1 } from "./slides/Slide1/Slide1";
import { Slide2 } from "./slides/Slide2/Slide2";
import { Slide3 } from "./slides/Slide3/Slide3";
import { Slide4 } from "./slides/Slide4/Slide4";
import { Slide5 } from "./slides/Slide5/Slide5";

interface Introduction {
  title: string;
}

export const Introduction: React.FC<Introduction> = ({ title }) => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);
  const ui = useUi();

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      case 3:
        return <Slide4 />;
      case 4:
        return <Slide5 />;
      default:
        return <Slide1 />;
    }
  };

  return (
    <StandardCase
      title={title}
      leftComponent={
        <ui.Scrollbars>
          <div className={styles.description}>{formatMessage(messages.description)}</div>
        </ui.Scrollbars>
      }
    >
      <div className={styles.content}>
        {renderSlide()}
        <SwitchOption
          onClick={setSelectedOption}
          activeItem={selectedOption}
          items={[
            {
              name: formatMessage(messages.option1),
            },
            {
              name: formatMessage(messages.option2),
            },
            {
              name: formatMessage(messages.option3),
            },
            {
              name: formatMessage(messages.option4),
            },
            {
              name: formatMessage(messages.option5),
            },
          ]}
        />
      </div>
    </StandardCase>
  );
};
